<template>
    <div class='page'>
        <div class="serinal_info">
          <van-image
            width="100"
            height="135"
             fit="cover"
             radius=10
            :src="info.cover_url"
          />
          <div class="info_desc_zone">
            <div class="info_name">{{info.name}}</div>
            <div class="info_desc">{{info.content}}</div>
            <div class="info_view">{{info.view_cnt}} 人观看</div>
          </div>
        </div>
        <div class="serinal_list">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text=""
                @load="onLoad"
              >
                <div v-if="!is_empty" class="list">
                  <template v-for="(item,index) in list" >
                    <div class="item" @click="showVideoIndex(item, index)"   :key="index"  >
                      <van-image
                        width="100%"
                        height="100%"
                        fit="cover"
                        :src="item.cover_url"
                      />
                      <div class="view_times_zone">
                        <span class="iconfont iconaixin1 "></span>
                        <span class="view_times" >{{item.favor_cnt}}</span>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="is_empty" class="empty">
                    <van-empty description="没有更多小视频" />
                </div>
              </van-list>
            </van-pull-refresh>
        </div>

        <van-popup v-model="pop_show"  @opened="bandShowVideo" :style="{ height: '100%',width:'100%' }"  >
          <div class='container_box' id="video_box">
            <div :class="{ 'van_swipe': is_index, 'van_swipe_height': is_index,'van_swipe_detail': !is_index, 'van_swipe_height_detail': !is_index }" >
              <!--vant van-swipe 滑动组件 -->
                <van-swipe 
                  ref="myswipe"
                  :show-indicators="false" 
                  @change="onChange" 
                  vertical 
                  :loop="false"
                >
                  <template  v-for="(item, index) in videoList"  >
                    <van-swipe-item :key="item.minivedio_id" class="product_swiper">
                        <v-touch  @doubletap="onDoubleTap" v-bind:doubletap-options="{intervall: 350}" v-on:tap="onTap">
                        <div class="video_container" :a="index">
                            <!--video属性
                            webkit-playsinline ios 小窗播放，使视频不脱离文本流，安卓则无效
                            微信内置x5内核，
                            x5-video-player-type="h5-page" 启用H5播放器,是wechat安卓版特性，添加此属性，微信浏览器会自动将视频置为全屏
                            x5-video-player-fullscreen="true" 全屏设置，设置为 true 是防止横屏
                            x5-video-orientation 控制横竖屏 landscape 横屏，portrain竖屏； 默认portrain
                            poster：封面
                            src：播放地址
                            -->
                                <video  class="video_box" loop webkit-playsinline="true" x5-video-player-type="h5-page"
                                      x5-video-player-fullscreen="true" playsinline preload="auto"
                                      :poster="item.cover_url" :src="item.mate_url" :playOrPause="playOrPause"
                                      @click1="pauseVideo"
                                      @pause="onPause($event,item,index)"
                                      @play="onPlay($event,item,index)"
                                >
                                </video>
                                <!-- 封面 -->
                                <img v-show="isVideoShow" class="play" @click1="playvideo" :src="item.cover_url"/>
                                <!-- 播放暂停按钮 -->
                                <img v-show="iconPlayShow" class="icon_play" @click1="playvideo"
                                    src="https://o-yzx.bysjy.com.cn/common/pause.png"/>
                        </div>
                        </v-touch>
                        <div class="container_bottom">
                          <div class="micro_name_wrap">
                            <div class="micro_name" @click="closePopVideo()">@{{item.name}}</div>
                            <div class="micro_view"><span class="iconfont iconyanjing_kai"></span> {{item.view_cnt}}</div>
                          </div>
                          <div class="micro_name_desc">
                            <span v-if="item.minivedio_group_name" @click="closePopVideo()" >#{{item.minivedio_group_name}}#</span> 
                            <span class="micro_name_desc_content">{{item.content}}</span>
                          </div>
                          <div class="micro_recommend">
                            <van-swipe :width="deviceWidth" :show-indicators="false" v-if="item.relation && item.relation.length> 0" >
                              <van-swipe-item v-for="(item, index) in item.relation" :key="index" class="recommend_item_wrap" >
                                <div  class="recommend_item" @click="gotoRelated(item)">
                                  <div class="recommend_item_type" >{{item.object_type_cn}}</div>
                                  <div class="recommend_item_divice" ></div>
                                  <div class="recommend_item_name">{{item.name}}</div>
                                </div>
                              </van-swipe-item>
                            </van-swipe>
                          </div>
                        </div>
                        <div class="tools_right">
                          <div v-if="0" class="tools_r_li"></div>
                          <div class="tools_r_li">
                            <div class="tools_r_icon" @click="bindFavor(item)" ><i class="iconfont iconxihuan font-size-27" :class="{'favor_active': item.is_favor, 'favor_animation': item.favor_animation }" ></i></div>
                            <div class="tools_r_num">{{item.favor_cnt}}</div>
                          </div>
                          <div class="tools_r_li"  @click="bindOpenComment(item)">
                            <div class="tools_r_icon"  ><span class="iconfont iconliuyan-fill font-size-27"></span></div>
                            <div class="tools_r_num">{{item.reply_cnt}}</div>
                          </div>
                          <div class="tools_r_li" @click="bindOpenPoster(item)">
                            <div class="tools_r_icon"><span class="iconfont iconfenxiang4 font-size-27"></span></div>
                            <div class="tools_r_num">分享</div>
                          </div>
                        </div>
                      </van-swipe-item>
                  </template>
                </van-swipe>
                
                <div class="border_progress" :style="'width:'+videoProcess+'%'"></div>

                <van-popup v-model="commentPop" position="bottom"  class="comment_container" >
                  <div class="comment_box"  >
                    <div class="comment_top"  @click="bindCloseComment">
                      <div class="comment_box_down"><span class="iconfont iconxiala2"></span></div>
                      <div class="comment_cnt">{{reply_total}}条评论</div>
                    </div>
                    <ul class="comment_ul">
                            <van-list
                              v-model="reply_loading"
                              :finished="reply_finished"
                              finished-text="没有更多了"
                              :immediate-check="false"
                              @load="OnReplyLoad"
                              v-if="reply_list.length >0"
                            >
                              <li class="comment_li" v-for="(item,index) in reply_list" :key="index"
                                  @click="replayUser(item,index, 2)">
                                  <div class="comment_author_left">
                                      <img :src="item.photo">
                                  </div>
                                  <div class="comment_author_right">
                                      <div class="comment_author_top">
                                          <div class="comment_author_name">{{item.user_name}}</div>
                                          <div class="icon-shoucang1_box" @click.stop="replayFavor(item,index)">
                                              <div class="icon_right_change"
                                                    :class="item.is_favor?'love_active':''">
                                                  <i class="iconfont iconxihuan"></i>
                                              </div>
                                              <div class="shoucang1_num">{{item.favor_cnt}}</div>
                                          </div>
                                      </div>
                                      <div class="comment_author_text">
                                          {{item.content}}<span class="comment_replay_time">{{item.create_time_cn}}</span></div>
                                  </div>
                                  <div class="clear"></div>
                                  <div class="comment_replay_box">
                                          <template v-for="(item2,index2) in item.child_replys">
                                            <div v-show="item.is_unfold || item2.is_local==1" class="comment_replay_li" :key="index2" @click.stop="replayChildUser(item,index,item2,index2)" >
                                                <div class="comment_replay_left">
                                                    <img :src="item2.photo">
                                                </div>
                                                <div class="comment_replay_right">
                                                    <div class="comment_replay_top">
                                                        <div class="comment_replay_name">{{item2.user_name}}</div>
                                                    </div>
                                                    <div class="comment_replay_text">
                                                        <span class="comment_replay_tips"  v-if="item2.up_minivedio_reply_reply_id">回复</span>
                                                        <span class="comment_replay_author" v-if="item2.up_minivedio_reply_reply_id"> {{item2.up_reply_user_name}}：</span>
                                                        {{item2.content}}
                                                        <span class="comment_replay_time">{{item2.create_time_cn}}</span>
                                                    </div>
                                                </div>
                                                <div class="clear"></div>
                                            </div>
                                          </template>
                                          <div v-if="item.child_reply_cnt>0" class="reply_more" >
                                              <div v-if="item.is_unfold == 0 " @click.stop="bandMoreChildReply(item,index)"><span class="iconfont iconsanjiaoxing"></span> 展开{{item.child_reply_cnt}}条回复</div>
                                              <div v-if="item.is_unfold == 1 && item.is_end ==0" @click.stop="bandMoreChildReply(item,index)"><span class="iconfont iconsanjiaoxing"></span> 展开更多回复</div>
                                              <div v-if="item.is_unfold == 1 && item.is_end ==1" @click.stop="bandUpChildReply(item,index)"><span class="iconfont iconsanjiaoxing1"></span> 收起</div>
                                          </div>
                                  </div>
                              </li>
                            </van-list>
                          <li class="no_message" v-if="reply_list.length==0">
                              <i class="iconfont iconfont_style iconmeiyoupinglun"></i>
                              <div class="no_message_tips">暂无评论</div>
                          </li>
                    </ul>
                  </div>
                </van-popup>

                <div ref="botFooter" class="comment_input_box"  v-show="commentPop">
                    <!--<form action="#" class="comment_form">-->
                    <input :placeholder="commentPlaceholder" @click="bandTextFocus" class="comment_input" v-model="reply_text" ref="content"
                          @keyup.enter="checkReply" @blur="bandTextBlur()"/>
                    <!--</form>-->
                    
                    <div class="comment_input_right" @click="checkReply">
                        <span class="iconfont iconsend comment_i" :class="canSend?'comment_i_active':''"></span>
                    </div>
                </div>
                <div class="pop_close" @click="closePopVideo()"><span class="iconfont iconfanhui " ></span></div>
            </div>

            <!-- 海报相关 TODO -->
            <div v-if="share_display" class="haibao-container">
                <div class="haibao-container-wrap">
                    <div class="haibao-container-img">
                        <img :src="share_poster.share_images" alt="">
                    </div>
                    <div class="haibao-tools">
                        <div class="tools-item" @click="bindShareTips">
                          <span class="iconfont iconweixin-copy tools-icon"></span>
                          <div class="tools-item-name">微信</div>
                        </div>
                        <div class="tools-item" @click="bindShareTips">
                          <span class="iconfont iconpengyouquan-copy tools-icon"></span>
                          <div class="tools-item-name">朋友圈</div>
                        </div>
                        <div class="tools-item" @click="bindDownTips">
                          <span class="iconfont iconziyuan4 tools-icon"></span>
                          <div class="tools-item-name">下载</div>
                        </div>
                    </div>
                    <div class="haibao-close">
                      <span class="iconfont icongouwuche " @click="bindClosePoster"></span>
                    </div>
                </div>
            </div>
            <div id="haibao-s-container" >
                <div class="haibao-s-bg">
                    <img src="https://o-yzx.bysjy.com.cn/common/micro_bg_2@3x.png.jpg" alt="">
                </div>
                <div class="s-info">
                  <div class="s-info-head">
                    <img :src="share_poster.user_photo" alt="">
                  </div>
                  <div  class="s-info-desc-zone">
                    <div  class="s-info-name">{{share_poster.user_name}}</div>
                    <div  class="s-info-desc">推荐了一个小视频给你~</div>
                  </div>
                </div>
                <qrcode-vue class="haibao-s-qr" :value="share_poster.qr_code" size="60" level="M"></qrcode-vue>
            </div>

            <share :is_show_share="is_show_share" v-on:hideShare="hideShare"></share>


            <template v-for="(item,index) in love_list">
              <v-touch @doubletap="onDoubleTap" v-bind:doubletap-options="{intervall: 350}" :key="index" v-on:tap="onDoubleTap">
              <div v-show="item.mouse_show" class="favour_animation" :key="index" :style="{top:item.mouse_top,left:item.mouse_left,transform: item.rotate}">
                <i class="iconfont iconxihuan font-size-27" :class="{'favor_active': 1, 'favor_animation2': item.mouse_animation2 }" ></i>
              </div>
              </v-touch>
            </template>
        </div>
        </van-popup>
    </div>
    
</template>
<script>
import Vue from "vue";
import {Image as VanImage,List,PullRefresh,Button,Popup,Empty,Divider,Toast ,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
import wx from "weixin-js-sdk";
import html2canvas from "html2canvas";
import QrcodeVue from "qrcode.vue";
import {util} from '@/utils/util'
import share from '../../components/common/share';
import VueTouch from 'vue-touch'

VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2
})
Vue.use(VueTouch, {name: 'v-touch'})


let videoProcessInterval;
let videoDurationInterval;

let single=0
export default {
        name: "serial",
        components:{
            [List.name]:List,
            [VanImage.name]:VanImage,
            [PullRefresh.name]:PullRefresh,
            [Divider.name]:Divider ,
            [Empty.name]:Empty ,
            [Popup.name]:Popup ,
            [Button.name]:Button,
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            [Icon.name]:Icon,
            [Popup.name]:Popup,
            [PullRefresh .name]:PullRefresh,
            [List .name]:List,
            QrcodeVue,
            share
        },
        data(){
            let u = navigator.userAgent;
            return {
                bodyShow: false,
                loading: false,
                finished: true,
                refreshing: false,
                pop_show: false,
                page:0,
                pageSize:6,
                list:[],
                total: 0,
                is_empty: 0,
                info: {},
                

                bodyShow: false,
                videoList:[],
                isLoading: false,
                isVideoShow: true,
                playOrPause: true,
                iconPlayShow: true,
                isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
                isiOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
                videoProcess: 0,//视频播放进度
                current: 0,
                commentPop: false,
                commentPlaceholder: "发表你的精彩评论~",
                
                canSend: false,//是否可以发送
                comment_text_bottom: 0,
                share_display: false,
                share_poster:{
                    share_images: 'http://oss.jishiyoo.com/images/file-1575343262684.jpg',
                    qr_code: '',
                    user_name: "",
                    user_photo: "",
                    train_name: "",
                    train_logo: "",
                },
                reply_page: 0,
                reply_pageSize: 10,
                reply_text: "",
                reply_list: [],
                reply_total: 0,
                reply_loading: false,
                reply_finished: false,
                reply_type: 1, // 回复类型 1: 顶级评论, 2:回复评论, 3: 回复-回复评论
                reply_current_item: "",  // 回复的当前评论
                reply_current_index: 0,  // 回复当前索引位置
                reply_current_child_item: "",  // 回复的回复
                reply_current_child_index: 0,  // 回复的索引
                videoComment: [],

                // 为公用一个页面处理
                is_index: true,
                video_page: 0,
                is_show_share:false,
                minivideo_id:"",
                page_type: 'index', // type index  assign single 对应加载不同接口
                is_first: 1,
                duration: 0,
                play_position: 0,
                is_same_index:false,// TODO 需要判断是否是同一个，来进行触发swipe,同一个没有办法触发onchange
                love_list:[]
            }
        },
        computed: {
          deviceWidth: function () {
            return (document.body.clientWidth/2)
          }
        },
        created() {
            //this.onPlayerPlay(this.$refs.videoPlayer.player)
            this.is_index = false
        },
        
        mounted() {
          let minivedio_id =this.util.getQueryStr('minivedio_id');
          this.getContent(minivedio_id);
        },
        methods:{
           bindWeiXin(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    _self.util.wxShare(wx, {
                        title: _self.share_title,
                        desc: _self.share_desc,
                        link: _self.share_link,
                        imgUrl: _self.share_imgUrl,
                    });
                });
            },
            setWxShareInfo(){
                var temp = this.videoList[this.current]
                this.share_title = temp.name
                this.share_desc = temp.content
                this.share_link = window.location.origin+this.util.urlPrefix+'/micro/single'+'?token='+this.util.token+'&minivideo_id='+temp.minivedio_id
                this.share_imgUrl = temp.cover_url
                this.bindWeiXin()
            },
            onLoadstart(item,index){
              
              let video = document.querySelectorAll('video')[index];
              console.log('加载itemitemitem!!!!!!!!!!', video.videoHeight, video.videoWidth)
              if(video.videoHeight/video.videoWidth<1.2){
                 console.log("设置高度",index)

                 video.setAttribute('style', 'top:30%')
              }
            },
            onDoubleTap(e){
                console.log("双击成功")
                console.warn("onDoubleTap!!!!!!!!!!!!!!!!!!!!!!!!!!",e)
                console.warn("e.targetTouches[0].clientX ",e.center )

                let rd = Math.floor((Math.random() * 45)*(Math.random()<0.5?1:-1));
                this.love_list.push({
                  mouse_top: e.center.y-18+'px',
                  mouse_left: e.center.x-12+'px',
                  mouse_show: true,
                  mouse_animation2: true,
                  rotate: 'rotate('+rd+'deg)',
                })
                const _this = this

                setTimeout(function(){ 
                  _this.love_list.shift()
                }, 450);
                
                let item = this.videoList[this.current]
                if(!item.is_favor){
                  this.bindFavor(item)
                }
            },
            onTap(){
              //  this.pauseVideo()
                const _this = this
                if(single){
                    console.log('单击拦截')
                    clearTimeout(single);
                    single=0;//清除定时器时也要让single=0;否则双击过后，下一次单击时single为true
                    return;
                }
                single = setTimeout(function () {
                    console.log('单击成功')
                    single=0;
                    _this.pauseVideo()
                }, 300)
            },
            onPause($event,item,index){
              const _this = this
              console.log("暂停，清除定时器，重置")

              //let video = document.querySelectorAll('video')[index];
              //this.play_position = video.currentTime.toFixed(1);

              this.playdurationEvent()
              _this.duration = 0
              _this.play_position = 0

              
              clearInterval(videoDurationInterval)
            },
            onPlay($event,item,index){
              const _this = this

              //清除定时器,重置当前时长
              clearInterval(videoDurationInterval)
              _this.duration = 0
              _this.play_position = 0
              // 启动定时器
              videoDurationInterval = setInterval(() => {
                  _this.duration ++
              }, 1000)

            },
            showVideoIndex(item, index){
                this.pop_show = true
                if(index==this.current){
                  this.is_same_index = true
                }else{
                  this.is_same_index = false
                }
                this.current = index

                this.setWxShareInfo()
                //this.$router.push(this.util.urlPrefix+'/micro/assign?'+'&token='+this.util.token);
            },
            closePopVideo(){
                console.log('closePopVideo')
                
                let video = document.querySelectorAll('video')[this.current];
                video.pause();
                this.pop_show = false
                this.iconPlayShow = true;
                clearInterval(videoProcessInterval)
            },
            bandShowVideo(){
              if(this.is_first==1 && this.current==0){
                console.log("这是第一次进入")
                this.initAutoVideo()
                this.viewTimesEvent()
              }else{
                if(this.is_same_index){
                  console.log("同一个")
                  this.initAutoVideo()
                  this.viewTimesEvent()
                }else{
                  this.$refs.myswipe.swipeTo(this.current,{immediate: true})
                }
                
                //this.initAutoVideo()
              }
              this.is_first = 0
            },
            onLoad() {
              //this.getScoresRecored()
            },
            onRefresh() {
              this.page = 0
              this.list =[]
              this.getGroupList(this.info.minivedio_group_id)
            },
            getContent(minivedio_id){ 
                const _self = this
                this.util.server.mini_minivedio.content({
                    data: {
                        minivedio_id: minivedio_id,
                    },
                    callback: (res => {
                        //_self.reply_loading = false

                        const { code, data, msg } = res;
                        if(code == 1) {
                           this.info = data
                            console.log("11",data)
                           _self.getGroupList(data.minivedio_group_id)
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            getGroupList(minivedio_group_id){ 
                const _self = this
                this.page ++
                this.util.server.mini_minivedio.group_list({
                    data: {
                        minivedio_group_id: minivedio_group_id,
                        page:this.page,
                        pagesize:this.pagesize
                    },
                    callback: (res => {
                        _self.loading = false
                        _self.refreshing = false
                        
                        const { code, data, msg } = res;
                        if(code == 1) {
                          data.items.forEach((value,index,array) => {
                            if(value.minivedio_id != _self.info.minivedio_id){// 排除自己
                              console.log("系列排除自身")
                              _self.list.push(value)
                              _self.videoList.push(value)
                            }
                          })
                          if(_self.list.length==0){
                              _self.is_empty = 1
                          }
                           //_self.list = _self.list.concat(data.items);
                            _self.total = data.total
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            OnReplyLoad(){
                var item = this.videoList[this.current];
                this.getReplyList(item)
            },
            gotoRelated(item){
                if(item.object_type=='course'){
                  this.$router.push(this.util.urlPrefix+'/curriculum/index?'+'&token='+this.util.token+'&course_id='+item.object_id+'&curIndex='+this.current);
                }else if(item.object_type=='training'){
                  this.$router.push(this.util.urlPrefix+'/training/index?'+'&token='+this.util.token+'&training_id='+item.object_id+'&curIndex='+this.current);
                }
                
            },
            bindDownTips(){
                this.util.showToast({
                    message: "长按分享海报图片保存到相册"
                });
            },
            bindShareTips(){
                this.is_show_share = true
            },
            hideShare(e){
                this.is_show_share = e;
            },
            // 评论相关
            bindOpenComment(item){
              // 重置
              this.reply_type = 1
              this.reply_text = ""
              this.commentPlaceholder = "发表你的精彩评论~"

              this.commentPop = true
              this.getReplyList(item)

              
            },
            bindCloseComment(){
              this.commentPop = false
            },
            bandTextFocus(){

            },
            bandTextBlur(){
                console.log("失去焦点")
                //this.reply_type = 1
                //this.reply_text = ""
                //this.commentPlaceholder = "发表你的精彩评论~"
            },
            bandMoreChildReply(item,index){
                console.log('bandMoreChildReply', item)
                // 是否已经展开, 如果已经展开则不显示
                item.is_unfold = 1
                this.childReplyList(item)
            },
            bandUpChildReply(item,index){
                // 是否已经展开, 如果已经展开则不显示
                item.is_unfold = 0
                //this.childReplyList(item)
            },
            checkReply(){
                console.log("1111")
                if(this.reply_type==1){
                  this.reply(
                    {
                      minivedio_id: this.videoList[this.current].minivedio_id,
                      reply_text: this.reply_text
                    }
                  )
                }else if(this.reply_type==2){
                  console.log("reply_type:", 2)
                  this.replyReply(
                    {
                      minivedio_id: this.videoList[this.current].minivedio_id,
                      minivedio_reply_id: this.reply_current_item.minivedio_reply_id,
                      up_minivedio_reply_reply_id: '',
                      reply_text: this.reply_text
                    }
                  )
                }else if(this.reply_type==3){
                  console.log("reply_type:", 3)
                  this.replyReply(
                    {
                      minivedio_id: this.videoList[this.current].minivedio_id,
                      minivedio_reply_id: this.reply_current_item.minivedio_reply_id,
                      up_minivedio_reply_reply_id: this.reply_current_child_item.minivedio_reply_reply_id,
                      reply_text: this.reply_text
                    }
                  )
                }
                
                // 回复完成后需要重置
                this.reply_text = ""
                this.commentPlaceholder = "发表你的精彩评论"
            },
            replayUser(item, index, type){
                console.log("replayUser")
                this.reply_text = ""
                this.reply_type = type
                this.reply_current_item = item
                this.reply_current_index = index
                this.commentPlaceholder  = "回复 @"+item.user_name
            },
            replayChildUser(item, index, child_item,child_index){
                console.log("replayChildUser")
                this.reply_text = ""
                this.reply_type = 3
                this.reply_current_item = item
                this.reply_current_index = index
                this.reply_current_child_item = child_item
                this.reply_current_child_index = child_index
                this.commentPlaceholder  = "回复 @"+child_item.user_name
            },
            replayFavor(item,index){
              console.log(item)
                item.is_favor =!item.is_favor
                if(item.is_favor){
                  item.favor_cnt ++
                }else{
                  item.favor_cnt --
                }
                this.favorReply(item)
            },
            bindClosePoster(){
              this.share_display = false
            },
            bindOpenPoster(item){
              this.handShare(item)
              // this.share_display = true
            },
            // 点赞相关
            bindFavor(item){
              this.favor(item)
              
              item.is_favor = !item.is_favor
              item.favor_animation = item.is_favor
              if(item.is_favor){
                item.favor_cnt ++
              }else{
                item.favor_cnt --
              }

            },
            initAutoVideo(){
              if (this.isiOS ||1 ) {
                  let nextvideo = document.querySelectorAll('video')[this.current];
                  this.iconPlayShow = false;
                  this.isVideoShow = false;
                  WeixinJSBridge.invoke('getNetworkType',{},function (e){
                    console.log("wxcallback")
                    nextvideo.play();
                  });
               }
            },
            // 视频处理相关
            onChange(index) {
                
                const _this = this
                //改变的时候 暂停当前播放的视频
                clearInterval(videoProcessInterval)
                this.resetReply()

                this.videoProcess = 0;
                let video = document.querySelectorAll('video')[this.current];
                video.pause();
                this.playOrPause = false;
                console.log('this.current1',this.current,index)
                this.current = index;
                
                //非ios切换直接自动播放下一个
                if (!this.isiOS ) {
                    this.isVideoShow = false;
                    setTimeout(() => {
                        this.pauseVideo()
                    }, 100)
                } else {
                    //ios官方禁止video自动播放，未找到合适的方法，如果您发现了，麻烦告诉我一下谢谢啦
                    //this.playOrPause = true;
                    this.iconPlayShow = false;
                    this.isVideoShow = false;
                    this.playOrPause = true;
                    let nextvideo = document.querySelectorAll('video')[this.current];
                    WeixinJSBridge.invoke('getNetworkType',{},function (e){
                      console.log("wxcallback")
                      nextvideo.play();
                    });
                    videoProcessInterval = setInterval(() => {
                        _this.changeProcess()
                    }, 100)
                }


                this.viewTimesEvent()
                this.setWxShareInfo()
                
            },
            pauseVideo() { //暂停\播放
                try {
                    let video = document.querySelectorAll('video')[this.current];
                    console.log("pauseVideo_" + this.current);
                    if (this.playOrPause) {
                        //暂停视频
                        // 1. 显示播放按钮
                        // 2. 清除进度条定时器
                        video.pause();
                        this.iconPlayShow = true;
                        clearInterval(videoProcessInterval)
                    } else {
                        video.play();
                        video.pause();
                        setTimeout(() => {
                            video.play();
                            this.iconPlayShow = false;
                            videoProcessInterval = setInterval(() => {
                                this.changeProcess(video)
                            }, 100)
                        }, 100)
                    }
                    this.playOrPause = !this.playOrPause;

                } catch (e) {
                    alert(e)
                }
            },
            onPlayerEnded(player){
                
            },
            resetReply(){// 翻页重置数据
                this.reply_page = 0
                this.reply_text = ""
                this.reply_list = []
                this.reply_total = 0
                this.reply_loading = false

                this.reply_type = 1
                this.reply_current_item = ""
                this.reply_current_index = 0
                this.reply_current_child_item = ""
                this.reply_current_child_index = 0

                this.commentPlaceholder = "发表你的精彩评论~"
            },
            playvideo(event){
                let video = document.querySelectorAll('video')[this.current];
                console.log("playvideo：" + this.current);
                this.isVideoShow = false;
                this.iconPlayShow = false;
                this.playOrPause = true
                video.play();
                
                videoProcessInterval = setInterval(() => {
                    this.changeProcess()
                }, 100)
            },
             //记录播放进度
            changeProcess() {
                let video = document.querySelectorAll('video')[this.current];
                let currentTime = video.currentTime.toFixed(1);
                let duration = video.duration.toFixed(1);
                this.play_position = currentTime;
                this.videoProcess = parseInt((currentTime / duration).toFixed(2) * 100)
            },
            handShare(item){
                const _this = this
                console.log('item',item)
                const userinfo = this.util.globalData.user.get()
                console.log('分享本地用户','userinfo', userinfo)
                
                this.share_poster.user_photo = userinfo.photo
                
                this.share_poster.user_name = userinfo.user_name

                this.share_poster.train_name = util.G_CONFIG.train_name
                this.share_poster.train_logo = util.G_CONFIG.logo
                //return false
                

               
                this.share_poster.qr_code = window.location.origin+this.util.urlPrefix+'/micro/single'+'?token='+this.util.token+'&minivideo_id='+item.minivedio_id
                console.log('this.share_poster', this.share_poster)
                this.$nextTick(() => {
                    

                    let content_html = document.getElementById("haibao-s-container"); //要转化的div
                    const _this = this;
                    let width = content_html.offsetWidth;
                    let height = content_html.offsetHeight;
                    let offsetTop = content_html.offsetTop;
                    let canvas = document.createElement("canvas");
                    let context = canvas.getContext("2d");
                    // let scaleBy = Math.ceil(window.devicePixelRatio);
                    let scaleBy = 3;
                    canvas.width = width * scaleBy;
                    canvas.height = (height + offsetTop) * scaleBy;
                    context.scale(scaleBy, scaleBy);

                    let offSetScrollTop = document.body.scrollTop || document.documentElement.scrollTop;

                    var opts = {
                        useCORS: true, //允许加载跨域的图片
                        tainttest: true, //检测每张图片都已经加载完成
                        scale: scaleBy, // 添加的scale 参数
                        canvas: canvas, //自定义 canvas
                        logging: false, //日志开关，发布的时候记得改成false
                        width: width, //dom 原始宽度
                        height: height, //dom 原始高度
                        backgroundColor: null,
                        scrollY: 0,
                    };
                    if (content_html) {
                        // html2canvas(content_html, {scale:2,logging:false,useCORS:true,backgroundColor: null,dpi: window.devicePixelRatio * 2}).then(function(canvas) {
                        html2canvas(content_html, opts).then(function(canvas) {
                        // canvas.getContext("2d").translate(-20,30);
                            _this.$nextTick(() => {
                                //let mCircle = document.getElementById("change-punch-haibao-icon");
                                // if (mCircle !== null) {
                                // mCircle.classList.remove("change-punch-haibao-icon-active");
                                // }
                                _this.share_display = 1
                                var url = canvas.toDataURL();
                                console.log("图片生成中...")
                                _this.share_poster.share_images = url;
                                _this.share_display = true
                            });
                            // const dataUrl = canvas.toDataURL();
                            // _this.mImgSrc = dataUrl;
                            // // _this.uploadShareImg(dataUrl);
                            // // _this.$emit('addUserScore',2)
                            // _this.$emit("uploadShareImg", dataUrl);

                            
                        });
                    }

                    
                });
                
            },
            getIndex(items){ //获取主页数据
                var config = items || {is_show_load:true}
                const _self = this
                this.video_page ++
                this.util.server.mini_minivedio.index({
                    data: {
                        page: this.video_page,
                        pagesize:3
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {
                            _self.videoList = _self.videoList.concat(data.items);
                            console.log("加载后视频列表", _self.videoList)
                            console.log("current", _self.current)
                            _self.isLoading = false 
                            if(_self.video_page!=1){
                              _self.$refs.myswipe.swipeTo(_self.current,{immediate: true})
                            }

                            this.$nextTick(() => {
                              items && items.callback && items.callback(res);
                            })
                            
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    }),
                    is_show_load: config.is_show_load || false
                });
            },
            getSingle(items){ //获取主页数据
                var config = items || {is_show_load:true}
                const _self = this
                this.util.server.mini_minivedio.content({
                    data: {
                        minivedio_id: _self.minivideo_id,
                    },
                    callback: (res => {
                        //_self.reply_loading = false

                        const { code, data, msg } = res;
                        if(code == 1) {
                            
                           _self.videoList.push(data);
                           console.log("_self.videoList",_self.videoList)
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
                
            },
            getUnifyData(items){//统一获取接口
               if(this.page_type=='index'){
                  this.getIndex(items)
               }else if(this.page_type=='single'){
                  this.getSingle(items)
               }
            },
            favor(items){ //获取主页数据
                console.log("current",this.current)
                const _self = this
                this.util.server.mini_minivedio.favor({
                    data: {
                        minivedio_id: items.minivedio_id,
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {
                            
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            favorReply(items){ //获取主页数据
                console.log("current",this.current)
                const _self = this
                this.util.server.mini_minivedio.favor_reply({
                    data: {
                        minivedio_reply_id: items.minivedio_reply_id,
                    },
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {
                            
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            getReplyList(items){ 
                const _self = this
                this.reply_page ++
                this.util.server.mini_minivedio.reply_list({
                    data: {
                        minivedio_id: items.minivedio_id,
                        page:this.reply_page,
                        pagesize:this.reply_pageSize
                    },
                    callback: (res => {
                        _self.reply_loading = false

                        const { code, data, msg } = res;
                        if(code == 1) {
                            // _self.reply_list = data.items
                            // Pre data 预处理数据有些参数需要设置默认值
                            data.items.forEach((value,index,array) => {
                                value.is_unfold = 0
                                value.page = 1
                                value.is_end = 0
                            })
                            _self.reply_list = _self.reply_list.concat(data.items);
                            //_self.reply_total = data.total
                            _self.reply_total = _self.videoList[_self.current].reply_cnt
                            
                             //判断是否存在下一页
                              //_self.reply_finished=false;
                              if(data.items.length==0){
                                  _self.reply_finished=true;
                              }

                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            reply(items){
                const _self = this
                this.util.server.mini_minivedio.reply({
                    data: {
                        minivedio_id: items.minivedio_id,
                        content: items.reply_text,
                    },
                    callback: (res => {
                        const { code, data, msg } = res
                        if(code == 1) {

                            _self.reply_text = ""
                            data.create_time_cn = '刚刚'
                            data.user_name = this.util.globalData.user.get().user_name
                            data.photo = this.util.globalData.user.get().photo
                            data.is_favor = 0
                            data.favor_cnt = 0
                            data.is_unfold = 0
                            data.child_replys = []
                            data.page = 1

                            _self.reply_total ++
                            _self.videoList[_self.current].reply_cnt = _self.reply_total
                            _self.reply_list.unshift(data)
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            replyReply(items){
                const _self = this
                this.util.server.mini_minivedio.reply_reply({
                    data: {
                        minivedio_id: items.minivedio_id,
                        minivedio_reply_id: items.minivedio_reply_id,
                        up_minivedio_reply_reply_id: items.up_minivedio_reply_reply_id,
                        content: items.reply_text,
                    },
                    callback: (res => {
                        const { code, data, msg } = res
                        console.log('replyReply', data)
                        if(code == 1) {

                            data.create_time_cn = '刚刚'
                            data.user_name = this.util.globalData.user.get().user_name
                            data.photo = this.util.globalData.user.get().photo
                            data.is_favor = 0
                            data.favor_cnt = 0
                            data.is_local = 1

                            _self.reply_list[_self.reply_current_index].child_replys.unshift(data) 
                            
                            _self.reply_total ++
                            _self.videoList[_self.current].reply_cnt = _self.reply_total
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            childReplyList(items){
                const _self = this
                this.util.server.mini_minivedio.child_reply_list({
                    data: {
                        minivedio_id: items.minivedio_id,
                        minivedio_reply_id: items.minivedio_reply_id,
                        pagesize: 5,
                        page: items.page
                    },
                    callback: (res => {
                        const { code, data, msg } = res
                        console.log('childReplyLists', data)
                        if(code == 1) {
                            console.log('items1',items)
                            let temp = _self.jsonToArr(items.child_replys,'minivedio_reply_reply_id')
                            data.items.forEach((value,index,array) => {
                                if(temp.indexOf(value.minivedio_reply_reply_id)==-1){
                                  items.child_replys.push(value)
                                }else{
                                  console.log("重复数据")
                                }
                                
                            })
                            if(items.child_replys.length >= data.total*1){ //如果已经全部加载完毕，显示收起
                                items.is_end = 1
                                console.log('items2',items)
                            }
                            items.page ++
                        }else{
                          this.util.showToast({
                              message: msg
                          });
                        }
                    }),
                    is_show_load: false
                });
            },
            jsonToArr(arr, key){
                let res = []
                arr.forEach((value,index,array) => {
                  res.push(value[key])
                })
                return res
            },
            viewTimesEvent(){
                //播放量+1
                this.util.server.event.event({
                    data: {
                        message:{
                            uid:this.util.getUserId.get(),
                            train_id:this.util.train_id,
                            minivedio_id: this.videoList[this.current].minivedio_id
                        },
                        code:10081, // 小视频浏览CODE
                    },
                    callback: (res => {})
                });
            },
            playdurationEvent(){
                //播放量+1
                this.util.server.event.event({
                    data: {
                        message:{
                            train_id:this.util.train_id,
                            minivedio_id: this.videoList[this.current].minivedio_id,
                            uid:this.util.getUserId.get(),
                            duration: this.duration,
                            play_position: this.play_position
                        },
                        code:10082, // 小视频浏览CODE
                    },
                    callback: (res => {})
                });
            },

        }
    }

</script>
<style scoped>
.serinal_info{
  display: flex;
  padding: 15px;
}
.info_desc_zone{
  flex: 1;
  margin-left: 12px;
  position: relative;
}
.info_name{
  height: 21px;
  line-height: 21px;
  font-size: 16px;
  color: #BCBCBE;
  font-weight: 600;
  overflow: hidden;
}
.info_desc{
  margin-top: 6px;
  font-size: 12px;
  color: #FFF;
  line-height: 19px;
  /* height: 72px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;

}
.info_view{
  position: absolute;
  color: #FFF;
  bottom: 0;
  font-size: 13px;
}
.list{
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item{
  position: relative;
  width:32%;
  height: 32vh;
  overflow: hidden;
  margin-bottom: 5px;
  /* flex: 0 0 32% */
}
.view_times_zone{
  position: absolute;
  left: 5px;
  bottom: 5px;
  color: #FFF;
}
.list:after {
  content: "";
  width: 32%;
  height: 0px;
  visibility: hidden;
}
.view_times_zone .iconaixin1{
  font-size: 13px;
}
.view_times{
  margin-left: 2px;
  font-size: 12px;
}

@supports (bottom: env(safe-area-inset-bottom)) {
	#video_box .van_swipe_height { 
    height: calc(100vh - 50px - env(safe-area-inset-bottom));
  }
  #video_box .van_swipe_height_detail { 
    height: calc(100vh - env(safe-area-inset-bottom));
  }
}

.container_box {
  width: 100vw;
  background: #000;
}

.van_swipe_detail {
  width: 100vw;
  height: calc(100vh);
  margin: 0 auto;
  position: relative;
}
.van_swipe {
  width: 100vw;
  height: calc(100vh - 50px);
  margin: 0 auto;
  position: relative;
}
.van-swipe {
  width: 100%;
  height: 100%;
}
.product_swiper {
  width: 100vw;
}
.video_container{
  height: 100%;
  /* background-image: linear-gradient(#3446a9, #C4C4C4, #3446a9); */
  /* background-image: linear-gradient(#1B1A2C, #C4C4C4,#1B1A2C); */
  overflow: hidden;
  /* position: relative; */
}
.van-swipe-item{
  height: 100%;
}
.play{
  width: 100%;
  height: 100%;
  top:0px;
  left: 0px;
  position: absolute;
  margin: auto;
  z-index: 999;
  object-fit: cover;
}
.icon_play{
  position: absolute;
  top: 42%;
  right: 0;
  left: 0;
  bottom: auto;
  margin: auto;
  z-index: 999;
  height: 60px;
  width: 60px;
  /* background: rgba(0, 0, 0, 0.5); */
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%
}
 .video_box {
  /*object-fit: fill !important;*/
  width: 100%;
  position: absolute;
  /* top: 30%; */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.border_progress {
    width: 0;
    height: 1px;
    background: rgba(255, 255, 255, 1);
    position: absolute;
    bottom: 0px;
    transition: .1s all;
}
.container_bottom{
  /* padding: 8px 8px 0px 8px; */
  z-index: 999;
  position: absolute;
  bottom: 0px;
  min-height: 50px;
  width: 100%;
  box-sizing: border-box;
}
.micro_name_wrap{
  display: flex;
  align-items: center;
  padding: 0px 8px;
}
.micro_name{
  height: 23px;
  /* font-size: 16px; */
  background-color: rgba(6, 43, 86, 0.31);
  padding: 4px 10px;
  border-radius: 10px 5px 5px 0px;
  color: #FFFFFF;
  /* font-family: monospace; */
  line-height: 23px;
}
.micro_view{
  margin-left: 9px;
  padding: 0px 6px;
  height: 23px;
  line-height: 23px;
  background: rgba(0, 102, 255, 0.6);
  border-radius: 10px;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
}
.iconyanjing_kai{
  font-size: 11px;
}
.micro_name_desc{
  margin-top: 8px;
  /* background: rgba(42, 61, 83, 0.46); */
  color: #FFFFFF;
  line-height: 20px;
  letter-spacing: 1px;
  font-size: 14px;
  /* padding: 10px 20px; */
  /* font-family: monospace; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  padding: 0px 8px;
}
.micro_recommend{
  margin-top: 5px;
  background: rgba(0, 0, 0, 0.18);
}
.recommend_item{
  height: 35px;
  line-height: 35px;
  display: flex;
}
.recommend_item_type{
  padding-left: 8px;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 600;
}
.recommend_item_divice{
  margin: 0 6px;
  width: 1px;
  background: #FFF;
  transform: scale(0.5);
}
.recommend_item_name{
  color: #FFFFFF;
  width: 120px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.tools_right{
  position: absolute;
  top:48%;
  right: 12px;
  z-index: 999;
}
.tools_r_li{
  width: 56px;
  height: 56px;
  text-align: center;
  margin-bottom: 11px;
}

.tools_r_num{
  margin-top: 7px;
  font-size: 12px;
  color: #FFF;
  text-shadow: 0px 0.5px 0px rgba(0, 0, 0, 0.27);
}
.font-size-27{
  font-size: 30px;
  color: #FFF;
  display: block;
  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16);
}

.favor_active {
  color: #f44;
}
.favor_animation{
  animation: showHeart .5s ease-in-out 0s;
}

@keyframes showHeart {
    0% {
        color: #f44;
        transform: scale(1);
    }

    25% {
        color: #fff;
        transform: scale(0);
    }

    80% {
        color: #f44;
        transform: scale(1.3);
    }

    100% {
        color: #f44;
        transform: scale(1);
    }
}

.favor_animation2{
  animation: showHeart2 0.5s linear 0s 2;
  transform-origin: 50% 80%;

}


@keyframes showHeart2 {
    0% {
        color: #f44;
        transform: scale(1) ;
        opacity: 0.8;
    }
    10% {
        color: #f44;
        transform: scale(1.4) ;
        opacity: 0.8;
    }
    20% {
        color: #f44;
        transform: scale(1.6)  ;
        opacity: 0.8;
    }

    30% {
        color: #f44;
        transform: scale(1.8)  ;
        opacity: 0.5;
    }
    40% {
        color: #f44;
        transform: scale(2)  ;
        opacity: 0.5;
    }
    50% {
        color: #f44;
        transform: scale(2.2) ;
        opacity: 0.5;
    }
    60% {
        color: #f44;
        transform: scale(2.5) ;
        opacity: 0.4;
    }
    70% {
        color: #f44;
        transform: scale(3) ;
        opacity: 0.3;
    }
    80% {
        color: #f44;
        transform: scale(3.5) ;
        opacity: 0.2;
    }
    100% {
        color: #f44;
        transform: scale(4) ;
        opacity: 0.1;
    }
}


.comment_container{
  border-radius: 12px 12px 0px 0px;
  background: #25252A;
}
.comment_box{
  text-align: center;
  padding-top: 10px;
  padding-bottom: 51px;
}
.comment_box_down{
  height: 18px;
  color: #FFFFFF;
}
.comment_cnt{
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 1px;
}
.comment_box .iconxiala2{
  font-size: 18px;
}
.comment_ul {
    height: calc(70vh);
    padding: 0px 15px 20px;
    overflow-y: auto;
}
.comment_li {
      margin-bottom: 20px;
      font-size: 14px;
      text-align: left;
  }

.comment_author_left {
    float: left;
}

.comment_author_left img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.comment_author_right {
    margin-left: 44px;
    padding-top: 4px;
}

.comment_author_top {
    position: relative;
}

.comment_author_name {
    margin-bottom: 6px;
    color: #BCBCBE;
    font-size: 12px;
}

.icon-shoucang1_box {
    position: absolute;
    right: 0px;
    top: 0;
    text-align: center;
    color: #777;
}

.comment_author_text {
    color: #FFF;
    margin-bottom: 10px;
    padding-right: 35px;
    font-size: 14px;
}

.comment_replay_box {
    padding-left: 46px;
    box-sizing: border-box;
}

.comment_replay_li {
    margin-bottom: 10px;
}

.comment_replay_left {
    float: left;
}

.comment_replay_left img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
}

.comment_replay_right {
    margin-left: 35px;
    padding-top: 2px;
}

.comment_replay_top {
    position: relative;
    margin-bottom: 6px;
}

.comment_replay_text {
    padding-right: 35px;
    margin-bottom: 10px;
    color: #555;
    font-size: 14px;
}

.comment_replay_tips {
  font-size: 14px;
}
.comment_replay_author{
  color: #999;
  font-size: 13px;
  margin-left: 6px;
} 
.comment_replay_time{
  color: #BEBEBE;
  font-size: 13px;
  margin-left: 6px;
}

.shoucang1_num {
    text-align: center;
    width: 30px;
    font-size: 12px;
    /* right: -4px; */
    position: relative;
}
.comment_replay_name{
    color: #BCBCBE;
    font-size: 12px;
}

.iconmeiyoupinglun {
    font-size: 120px;
    color: #FFF;
}

.love_active {
    color: #f44;
}
.icon_right_change .iconxihuan{
  font-size: 18px;
}
.comment_input_box {
  position: fixed;
  bottom:0px;
  opacity:1;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #585858;
  background: #1F1F21;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
}
.comment_input{
  flex: 1;
  background: #353539;
  color: #fff;
  border-radius: 16px;
  height: 36px;
  border: none;
  padding-left: 10px;
}
.comment_input_right{
  width: 36px;
  text-align: center;
}
.comment_i{
  font-size: 22px;
  line-height: 36px;
  color: #999;
  transition: .3s;
}
.comment_i_active {
  color: #f44;
}
.haibao-container{
  position: fixed;
  z-index: 2000;
  background: linear-gradient(to bottom right, RGBA(254, 247, 221, 1), RGBA(252, 219, 142, 1));
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  padding: 28px;
  box-sizing: border-box;
}
.haibao-container-wrap{
  position: relative;
  width: 100%;
  height: 100%;
}
.haibao-container-img{
  width: 100%;
  height: calc(100vh - 195px);
  text-align: center;
  /* height: 100%; */
}
.haibao-container-img img{
  width: 100%;
  height: 100%;
  
  object-fit:contain;
  border-radius: 10px;
}
.haibao-tools{
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 53px;
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;
}
.tools-item{
  padding:0 10px;
  text-align: center;
}
.tools-item .iconweixin-copy{
  color: #53DE85;
}
.tools-item .iconpengyouquan-copy{
  color: #53DE85;
}
.tools-item .iconziyuan4{
  color: #FFAF0F;
}

.tools-icon{
  font-size: 45px;
}
.tools-item-name{
  margin-top: 7px;
  color: #FFFFFF;
  font-size: 12px;
}
.haibao-close{
  position: absolute;
  bottom: 0px;
  text-align: center;
  width: 100%;
}
.haibao-close .icongouwuche{
  color: white;
  font-size: 35px;
}

#haibao-s-container{
    position: fixed;
    left: -9999px;
    top: -9999px; 
    /* left: 0px;
    top: 0px; */
    width: 319px;
    height: 491px;
    z-index: 3999;
    border-radius: 10px;
}

.haibao-s-bg img{
  width: 319px;
  height: 491px;
  vertical-align: bottom;
}
.s-info{
  position: absolute;
  bottom: 15px;
  left: 10px;
  display: flex;
}
.s-info-head img{
  height: 37px;
  width: 37px;
  border-radius: 50%;
}
.s-info-desc-zone{
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.s-info-name{
  font-size: 12px;
  color: #E18300;
}
.s-info-desc{
  font-size: 12px;
  font-weight: bold;
  color: #E18300;
}
.haibao-s-qr{
  position: absolute;
  bottom: 6px;
  right: 5px;
  width: 62px;
  height: 62px;
  /* border: 1px #777 dashed; */
  padding: 2px
}
.micro_name_desc_content{
  padding-left: 5px;
}
.reply_more{
  color: #BCBCBE;
  font-size: 14px;
  position: relative;
  padding-left: 12px;
}
.reply_more .iconsanjiaoxing{
  font-size: 9px;
  position: absolute;
  top: 2px;
  left: 0px;
}
.reply_more .iconsanjiaoxing1{
  font-size: 9px;
  position: absolute;
  top: 2px;
  left: 0px;
}

.container_box >>> .info-box{
  z-index: 2990;
}
.container_box >>> .info-to-wx{
  z-index: 2999;
}
.no_message_tips{
  color: #FFF;
}
.favour_animation{
  position:absolute;
  z-index: 2000;
}
.pop_close{
  z-index: 1000;
  position: absolute;
  top:12px;
  left: 8px;
  color: #FFF;
}
.pop_close .iconfanhui{
  font-size: 20px;
}
.page{
  background: #14131E;
  min-height: 100vh;
}
</style>